module.exports = __webpack_public_path__ + "img/piano-cerimonia.71fcb468.jpg";